import React from 'react'
import { Link } from 'gatsby'
import { Box, Heading, Button } from 'theme-ui'
import Section from '@components/Section'

/**
 * Shadow me to add your own content
 */

const styles = {
  heading: {
    mb: 4,
    span: {
      color: `omegaDark`
    }
  },
  running: {
    color: `omegaDark`,
    fontWeight: `body`,
    width: `5/6`
  }
}

export default () => (
  <>
    <Section>
      <Heading variant='h1' sx={styles.heading}>
        <span>Swift</span> on Apple M1!
      </Heading>
      <Heading variant='h3' sx={styles.running}>
      Swift-Arm is excited to announce that, thanks to <b>MacStadium</b>, we can now test Swift on Arm using the new M1 Mac Mini.
      </Heading>
    </Section>
    <Box variant='buttons.group' sx={styles.buttons}>
      <Button as={Link} to='/powered-by-macstadium/'>
        Read More...
      </Button>
    </Box>
  </>
)
